module.exports = __webpack_public_path__ + "img/alinoDetectTowerMaster.c5c671ab.webp";